/* =========================
   header-tooltip.js
   - Header Style property buttons (Rod Pocket / Grommet Top / Pencil Pleat / Pinch Pleated)
   - Conditional Grommet Color swatches (shown when Grommet Top selected)
   - Conditional Lining Color swatches (shown when Lining variant = Yes)
   - Hover preview on all image swatches
========================= */

/* ---------- Helpers ---------- */
function normalizeKey(v){
  return String(v || "")
    .trim()
    .toLowerCase()
    .replace(/[()]/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function niceLabel(key){
  return String(key || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (m) => m.toUpperCase());
}

function absUrl(u){
  if (!u) return "";
  const s = String(u).trim();
  if (!s) return "";
  if (s.startsWith("//")) return "https:" + s;
  if (s.startsWith("/")) return window.location.origin + s;
  return s;
}

function safeParseJson(el){
  if (!el) return {};
  try { return JSON.parse(el.textContent || "{}"); } catch(e){ return {}; }
}

function hasAnyValue(map){
  if (!map) return false;
  return Object.values(map).some(v => v && String(v).trim().length);
}

/* ---------- Swatch renderer (with hover preview) ---------- */
function renderImageSwatches({ wrap, map, input, order, datasetKey = "key", valueFormatter = niceLabel }){
  if (!wrap || !input || !map) return;

  wrap.innerHTML = "";
  const keys = (Array.isArray(order) && order.length) ? order : Object.keys(map);

  keys.forEach((k) => {
    const url = absUrl(map[k]);
    if (!url) return;

    const btn = document.createElement("button");
    btn.type = "button";
    btn.dataset[datasetKey] = k;
    btn.className = "pg-swatch-btn";
    btn.setAttribute("aria-label", valueFormatter(k));

    const img = document.createElement("img");
    img.src = url;
    img.alt = valueFormatter(k);
    img.loading = "lazy";
    img.className = "pg-swatch-img";

    const label = document.createElement("div");
    label.className = "pg-swatch-label";
    label.textContent = valueFormatter(k);

    const preview = document.createElement("div");
    preview.className = "pg-swatch-preview";
    const big = document.createElement("img");
    big.src = url;
    big.alt = valueFormatter(k);
    big.loading = "lazy";
    preview.appendChild(big);

    btn.appendChild(img);
    btn.appendChild(label);
    btn.appendChild(preview);

    btn.addEventListener("click", () => {
      wrap.querySelectorAll(".pg-swatch-btn").forEach(b => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      input.value = valueFormatter(k);
    });

    wrap.appendChild(btn);
  });
}

/* =========================
   Main
========================= */
document.addEventListener("DOMContentLoaded", () => {
  const picker = document.querySelector("variant-picker");

  /* ---------- Inject CSS (once) ---------- */
  if (!document.getElementById("pg-swatch-css")) {
    const style = document.createElement("style");
    style.id = "pg-swatch-css";
    style.textContent = `
      .pg-swatch-btn{
        position:relative;
        border:2px solid rgba(0,0,0,.12);
        border-radius:10px;
        padding:6px;
        background:#fff;
        cursor:pointer;
        display:inline-flex;
        flex-direction:column;
        align-items:center;
      }
      .pg-swatch-btn.is-active{
        border-color:#111;
        outline:2px solid #111;
        outline-offset:2px;
      }
      .pg-swatch-img{
        width:70px;
        height:70px;
        object-fit:cover;
        display:block;
        border-radius:6px;
      }
      /* Header style swatches */
      .pg-swatch-btn--header .pg-swatch-img{
        width:100px;
        height:100px;
      }
      .pg-swatch-btn--header{
        min-width:100px;
      }
      .pg-swatch-label{
        font-size:12px;
        margin-top:6px;
        text-align:center;
        line-height:1.3;
        width:100px;
        white-space:normal;
        word-break:break-word;
      }
      [id^="header-btns-"]{
        gap:12px;
      }
      .pg-swatch-preview{
        display:none;
        position:absolute;
        left:50%;
        transform:translateX(-50%);
        top:calc(100% + 8px);
        width:220px;
        background:#fff;
        border:1px solid rgba(0,0,0,.12);
        border-radius:12px;
        padding:8px;
        box-shadow:0 8px 24px rgba(0,0,0,.14);
        z-index:9999;
        pointer-events:none;
      }
      .pg-swatch-preview img{
        width:100%;
        height:auto;
        display:block;
        border-radius:8px;
      }
      .pg-swatch-btn:hover .pg-swatch-preview{ display:block; }
      @media (max-width: 768px){
        .pg-swatch-preview{ display:none !important; }
      }
    `;
    document.head.appendChild(style);
  }

  /* =========================
     A) Header Style selector
     If shop metafield "header_style_images" is set → image swatches
     Otherwise → text buttons (fallback)
  ========================= */
  const headerBtnWrap   = document.querySelector('[id^="header-btns-"]');
  const headerPropInput = document.querySelector('[id^="header-prop-"]');
  const hImgEl          = document.querySelector('[id^="header-style-imgs-"]');
  const hImgMap         = hImgEl ? safeParseJson(hImgEl) : null;
  const _allowedAttr  = headerBtnWrap ? headerBtnWrap.getAttribute('data-allowed-headers') : null;
  const _allowedSet   = _allowedAttr ? new Set(_allowedAttr.split(',').map(s => s.trim())) : null;
  const HEADER_ORDER  = ["Rod Pocket", "Grommet Top", "Pencil Pleat", "Pinch Pleated"].filter(n => !_allowedSet || _allowedSet.has(n));

  function getSelectedHeader(){
    if (headerPropInput) return headerPropInput.value;
    return null;
  }

  function selectHeader(name){
    if (headerPropInput) headerPropInput.value = name;
    if (headerBtnWrap){
      headerBtnWrap.querySelectorAll(".is-active").forEach(b => b.classList.remove("is-active"));
      const btn = headerBtnWrap.querySelector(`[data-header-key="${name}"], [data-header-btn="${name}"]`);
      if (btn) btn.classList.add("is-active");
    }
    refreshGrommetBox();
  }

  if (hImgMap && hasAnyValue(hImgMap) && headerBtnWrap) {
    // ── Image swatch mode ──
    headerBtnWrap.innerHTML = "";

    HEADER_ORDER.forEach((name, i) => {
      const url = absUrl(hImgMap[name]);
      if (!url) return;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "pg-swatch-btn pg-swatch-btn--header" + (i === 0 ? " is-active" : "");
      btn.setAttribute("data-header-key", name);
      btn.setAttribute("aria-label", name);

      const img = document.createElement("img");
      img.src = url; img.alt = name; img.loading = "lazy"; img.className = "pg-swatch-img";

      const lbl = document.createElement("div");
      lbl.className = "pg-swatch-label"; lbl.textContent = name;

      const preview = document.createElement("div");
      preview.className = "pg-swatch-preview";
      const big = document.createElement("img");
      big.src = url; big.alt = name; big.loading = "lazy";
      preview.appendChild(big);

      btn.appendChild(img); btn.appendChild(lbl); btn.appendChild(preview);
      btn.addEventListener("click", () => selectHeader(name));
      headerBtnWrap.appendChild(btn);
    });

  } else {
    // ── Text button mode (fallback) ──
    document.querySelectorAll("[data-header-btn]").forEach((btn) => {
      btn.addEventListener("click", () => selectHeader(btn.getAttribute("data-header-btn")));
    });
  }

  /* =========================
     B) Grommet Color (shown when Header = Grommet Top)
     Reads: JSON id="grommet-colors-..."
     UI:    [data-grommet-box] > [data-grommet-swatches]
            [data-grommet-prop] hidden input
  ========================= */
  const gcEl  = document.querySelector('[id^="grommet-colors-"]');
  const gcMap = safeParseJson(gcEl);

  const gBox       = document.querySelector("[data-grommet-box]");
  const gSwWrap    = document.querySelector("[data-grommet-swatches]");
  const gPropInput = document.querySelector("[data-grommet-prop]");

  function initGrommet(){
    if (!gcEl || !gBox || !gSwWrap || !gPropInput) return;
    if (!hasAnyValue(gcMap)) { gBox.style.display = "none"; return; }

    renderImageSwatches({
      wrap: gSwWrap,
      map: gcMap,
      input: gPropInput,
      order: ["gold", "silver", "white", "black"],
      datasetKey: "color",
      valueFormatter: (k) => niceLabel(k)
    });
  }

  function refreshGrommetBox(){
    if (!gBox || !gPropInput) return;

    const val  = getSelectedHeader() || "";
    // Show if header is grommet AND either image swatches OR fallback text buttons exist
    const hasFallbackBtns = !!gBox.querySelector("[data-grommet-fallback]");
    const show = val.toLowerCase().includes("grommet") &&
                 (hasAnyValue(gcMap) || hasFallbackBtns);

    gBox.style.display = show ? "block" : "none";
    if (!show) {
      gPropInput.value = "";
      gPropInput.removeAttribute("name");
      if (gSwWrap) gSwWrap.querySelectorAll(".pg-swatch-btn").forEach(b => b.classList.remove("is-active"));
    } else {
      gPropInput.setAttribute("name", "properties[Grommet Color]");
      // Auto-select first option if nothing selected yet
      if (!gPropInput.value) {
        if (gSwWrap) {
          const firstBtn = gSwWrap.querySelector(".pg-swatch-btn");
          if (firstBtn) {
            firstBtn.classList.add("is-active");
            gPropInput.value = firstBtn.getAttribute("aria-label") || "Gold";
          }
        } else {
          // Fallback text button mode
          const firstBtn = gBox.querySelector("[data-grommet-fallback]");
          if (firstBtn) {
            firstBtn.classList.add("is-active");
            gPropInput.value = firstBtn.getAttribute("data-grommet-fallback") || "Gold";
          }
        }
      }
    }
  }

  /* =========================
     C) Lining Color (shown when Lining variant = "Yes")
     Reads: JSON id="lining-imgs-..."
     UI:    [data-lining-color-box] > [data-lining-color-swatches]
            [data-lining-color-prop] hidden input
  ========================= */
  (function initLiningColors(){
    if (!picker) return;

    const lColorBox  = document.querySelector("[data-lining-color-box]");
    const lColorWrap = lColorBox && lColorBox.querySelector("[data-lining-color-swatches]");
    const lColorProp = document.querySelector("[data-lining-color-prop]");
    if (!lColorBox || !lColorWrap || !lColorProp) return;

    // Parse image list
    const imgEl = document.querySelector('[id^="lining-imgs-"]');
    var imgUrls = [];
    if (imgEl) {
      try { imgUrls = JSON.parse(imgEl.textContent); } catch(e) {}
    }

    // Map C1-BL-N number → URL
    var codeRe = /C1-BL-(\d+)/i;
    var urlByNum = {};
    imgUrls.forEach(function(url){
      var m = codeRe.exec(url);
      if (m) urlByNum[parseInt(m[1])] = url;
    });

    // Fallback: if the product has no lining_color_images metafield, use shared CDN images
    if (Object.keys(urlByNum).length === 0) {
      urlByNum = {
        1:  "//northcurtain.ca/cdn/shop/files/C1-BL-1-Light-Grey.png?width=300",
        2:  "//northcurtain.ca/cdn/shop/files/C1-BL-2-Dark-Green.png?width=300",
        3:  "//northcurtain.ca/cdn/shop/files/C1-BL-3-Midnigh-Navy.png?width=300",
        4:  "//northcurtain.ca/cdn/shop/files/C1-BL-4-Avocado-Green.png?width=300",
        5:  "//northcurtain.ca/cdn/shop/files/C1-BL-5-Black.png?width=300",
        6:  "//northcurtain.ca/cdn/shop/files/C1-BL-6-Beige.png?width=300",
        7:  "//northcurtain.ca/cdn/shop/files/C1-BL-7-Wine-Red.png?width=300",
        8:  "//northcurtain.ca/cdn/shop/files/C1-BL-8-Blue.png?width=300",
        9:  "//northcurtain.ca/cdn/shop/files/C1-BL-9-Pink.png?width=300",
        10: "//northcurtain.ca/cdn/shop/files/C1-BL-10-Dark-Grey.png?width=300"
      };
    }

    // Fallback color names by C1-BL number (matches variant title order from the lining product)
    var nameByNum = {
      1:"Light Grey", 2:"Dark Grey", 3:"Dark Green", 4:"Midnight Navy",
      5:"Avocado Green", 6:"Black", 7:"Beige", 8:"Wine Red", 9:"Blue", 10:"Pink"
    };

    function labelFromUrl(url, num){
      // Try to extract color name from filename after C1-BL-N
      var m = /C1-BL-\d+-([a-z][a-z0-9-]+?)(?:_|\.|\?|$)/i.exec(url);
      if (m) return m[1].replace(/-/g," ").replace(/\b\w/g, c => c.toUpperCase());
      return nameByNum[num] || "Color " + num;
    }

    var swatchesBuilt = false;

    function buildSwatches(){
      if (swatchesBuilt) return;
      swatchesBuilt = true;

      var nums = Object.keys(urlByNum).map(Number).sort((a, b) => a - b);
      nums.forEach(function(num){
        var url   = urlByNum[num];
        var label = labelFromUrl(url, num);

        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "pg-swatch-btn";
        btn.setAttribute("aria-label", label);

        var img = document.createElement("img");
        img.src = url; img.alt = label; img.loading = "lazy"; img.className = "pg-swatch-img";

        var lbl = document.createElement("div");
        lbl.className = "pg-swatch-label"; lbl.textContent = label;

        var preview = document.createElement("div");
        preview.className = "pg-swatch-preview";
        var big = document.createElement("img");
        big.src = url; big.alt = label; big.loading = "lazy";
        preview.appendChild(big);

        btn.appendChild(img); btn.appendChild(lbl); btn.appendChild(preview);

        btn.addEventListener("click", function(){
          lColorWrap.querySelectorAll(".pg-swatch-btn").forEach(b => b.classList.remove("is-active"));
          btn.classList.add("is-active");
          lColorProp.value = label;
        });

        lColorWrap.appendChild(btn);
      });
    }

    function getLiningSelection(){
      var result = null;
      picker.querySelectorAll("fieldset.option-selector").forEach(function(fs){
        var legend = fs.querySelector("legend");
        if (legend && /lining/i.test(legend.textContent)){
          var c = fs.querySelector('input[type="radio"]:checked');
          if (c) result = c.value;
        }
      });
      return result;
    }

    var isDirectLining = !!document.querySelector("[data-lining-always-show]");

    function refreshLiningColors(){
      var show;
      if (isDirectLining) {
        show = true; // blackout-velvet: lining always included, always show color picker
      } else {
        var val = getLiningSelection();
        show = (val === "Yes");
      }
      lColorBox.style.display = show ? "block" : "none";
      if (show){
        buildSwatches();
      } else {
        lColorProp.value = "";
        lColorWrap.querySelectorAll(".pg-swatch-btn").forEach(b => b.classList.remove("is-active"));
      }
    }

    picker.addEventListener("change", refreshLiningColors);
    picker.addEventListener("click", (e) => {
      if (e.target.closest('input[type="radio"]') || e.target.closest("label")){
        setTimeout(refreshLiningColors, 0);
      }
    });

    refreshLiningColors();
  })();

  /* =========================
     Init
  ========================= */
  initGrommet();
  refreshGrommetBox();

  if (picker) {
    picker.addEventListener("change", refreshGrommetBox);
  }
});
